import { SQLiteDBConnection } from '@capacitor-community/sqlite';

import { SqliteDatabase } from './sqlite-database';

export class SeenOrdersRepository extends SqliteDatabase {
  constructor() {
    super('seen_orders_db', 1);
  }

  public async addOrders(orderIds: string[]): Promise<void> {
    if (orderIds.length === 0) {
      return;
    }

    const placeholders = orderIds.map(() => '(?, ?)').join(', ');
    const insertQuery = `
      INSERT OR IGNORE INTO seen_orders (order_id, seen_at)
      VALUES ${placeholders};
    `;

    const now = Date.now();
    const params = orderIds.flatMap((id) => [id, now]);

    await this.withConnection(async (db) => {
      await db.run(insertQuery, params);
      await this.persistChanges();
    });
  }

  public async getSeenOrderIds(): Promise<string[]> {
    const selectQuery = `
      SELECT order_id FROM seen_orders;
    `;

    return this.withConnection(async (db) => {
      const result = await db.query(selectQuery);

      return (result.values ?? []).map((row) => row.order_id as string);
    });
  }

  public async cleanUpOldOrders(olderThan: number): Promise<void> {
    const deleteQuery = `
      DELETE FROM seen_orders WHERE seen_at < ?;
    `;

    await this.withConnection(async (db) => {
      await db.run(deleteQuery, [olderThan]);
      await this.persistChanges();
    });
  }

  protected async onInitTables(
    dbConnection: SQLiteDBConnection,
  ): Promise<void> {
    const createTableQuery = `
      CREATE TABLE IF NOT EXISTS seen_orders (
        order_id TEXT PRIMARY KEY NOT NULL,
        seen_at INTEGER NOT NULL
      );
    `;

    await dbConnection.execute(createTableQuery);
  }
}
